"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nativeApi_1 = require("./nativeApi");
/**
 * Find slots which belong exactly to root element,
 * and not belong to other nested elements
 */
function findSlots(shadowRoot) {
    var before = nativeApi_1.isNativeApiExposed();
    nativeApi_1.exposeNativeApi(true);
    var slots = [];
    var renderRootsStack = [];
    var foreignSlotsStack = [];
    function find(root) {
        var child = root.firstElementChild;
        while (child) {
            if (child.tagName.toUpperCase() === 'SLOT') {
                if (renderRootsStack.length === foreignSlotsStack.length) {
                    // we've met the same number of slots and render-targets
                    // this slot must belong to our component
                    slots.push(child);
                }
                else {
                    foreignSlotsStack.push(child);
                    find(child);
                    foreignSlotsStack.pop();
                }
            }
            else if (child.tagName.toUpperCase() === 'RENDER-TARGET') {
                renderRootsStack.push(child);
                find(child);
                renderRootsStack.pop();
            }
            else {
                find(child);
            }
            child = child.nextElementSibling;
        }
    }
    find(shadowRoot);
    nativeApi_1.exposeNativeApi(before);
    return slots;
}
exports.findSlots = findSlots;
// idea is that if we meet render-target we remember it
// and if we've met render-traget and meet slot, that slot is foreign
// <x-outer>
// <render-target>
// <h1>
// <x-inner>
// <render-traget>
// <h2>
// <slot> the first slot after render-target belongs to the parent of that render-target
// <slot> of x-outer
// ...
// </slot>
// </slot>
// </h2>
// </render-target>
// </x-inner>
// </h1>
// </render-target>
// </x-outer>
function findAncestor(node, predicate) {
    if (node.parentNode === null) {
        return null;
    }
    else if (predicate(node.parentNode)) {
        return node.parentNode;
    }
    else {
        return findAncestor(node.parentNode, predicate);
    }
}
exports.findAncestor = findAncestor;
